import { action, computed, observable } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import * as constants from 'Constants';
import PhotoMediaStore from 'stores/Model/PhotoMediaStore';
import { deserializeWithMappers, setFieldValues, deserializeDate } from 'stores/Utils';


class DealStore {

  @setter @observable id;
  @setter @toggle @observable displayListing;
  @setter @toggle @observable featured;
  @setter @observable logoMedia;
  @setter @observable partnerName;
  @setter @observable partnerTagline;
  @setter @observable offer;

  static create(data={}) {
    const instance = new DealStore();
    setFieldValues(instance, data);
    return instance;
  }

  static getDefaults() {
    return {
      "id": null,
      "displayListing": false,
      "featured": false,
      "logoMedia": new PhotoMediaStore(),
      "partnerName": "",
      "partnerTagline": "",
      "offer": "",
    };
  }

  constructor(defaults=DealStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  @action reset(defaults=DealStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  getDeserializeMappers() {
    return [
      {"field": "id"},
      {"field": "displayListing", "accessor": "display_listing"},
      {"field": "featured"},
      {"field": "logoMedia", "accessor": "logo_media", "type": constants.DESERIALIZE_TYPE_OBJECT, "cls": PhotoMediaStore},
      {"field": "partnerName", "accessor": "partner_name"},
      {"field": "partnerTagline", "accessor": "partner_tagline"},
      {"field": "offer"},
    ];
  }

  @action deserialize(data) {
    deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }

  @computed get redemptionLink() {
    if (!this.id) return "";
    return `${BASE_CONSOLE_URL}/partner-deals/${this.id}/redemption`;
  }

}


export default DealStore;

